import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of, timer} from 'rxjs';
import {UserInfo} from '@app/model/user-info.model';
import {UrlHelperService} from '@app/shared/util/url-helper.service';
import {catchError, publishReplay, refCount, switchMap} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UserInfoService {
	public static readonly pollingIntervalMilliseconds = 60000;

	readonly #userInfo$: Observable<UserInfo>;
	readonly #timer$ = timer(0, UserInfoService.pollingIntervalMilliseconds);

	constructor(private http: HttpClient, private urlHelper: UrlHelperService) {
		this.#userInfo$ = this.#timer$.pipe(
			switchMap(() => this.fetchUserInfo$()),
			publishReplay(1), refCount()
		);
	}

	getUserInfo$(): Observable<UserInfo> {
		return this.#userInfo$;
	}

	private fetchUserInfo$(): Observable<UserInfo> {
		return this.http.get<UserInfo>(this.urlHelper.prepareApiPath('user-info')).pipe(
			catchError(() => of(anonymous()))
		);
	}
}


function anonymous(): UserInfo {
	return {
		anonymous: true,
		hasExtendedAccess: false,
		fullName: undefined
	};
}
